export const iconNames = [
  "dice",
  "dice-one",
  "dice-two",
  "dice-three",
  "dice-four",
  "dice-five",
  "dice-six",
  "plus",
  "chevron-right",
  "arrow-left",
  "user",
  "history",
  "calculator",
  "cube",
  "dice-d6",
  "door-open"
];

export default {
  name: "dr-icon",
  props: {
    name: {
      type: String,
      required: true,
      validator: function(value) {
        return iconNames.indexOf(value) !== -1;
      }
    },
    reverse: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small",
      validator: function(value) {
        return ["small", "medium", "large", "x-large"].indexOf(value) !== -1;
      }
    }
  }
};
